export interface StoryFacetedSearchTagItemOutputApiModel {
    name: string;
    color: string;
    stories_count: number;
    selected: boolean;
}

export interface StoryFacetedSearchPeopleItemOutputApiModel {
    id: number;
    name: string;
    avatar: string;
    stories_count: number;
    selected: boolean;
}

export interface StoryFacetedSearchCampaignItemOutputApiModel {
    id: number;
    name: string;
    stories_count: number;
    selected: boolean;
}

export interface StoryFacetedSearchOutputApiModel {
    tags: StoryFacetedSearchTagItemOutputApiModel[];
    players: StoryFacetedSearchPeopleItemOutputApiModel[];
    campaigns: StoryFacetedSearchCampaignItemOutputApiModel[];
    frequent_tags?:any
    internal_tags?:any
}